<div class="c-pie c-pie--outline" [ngClass]="{'c-pie--over': vm.value > 50}" [ngStyle]="vm.percentStyle">
	<div class="c-pie__fill"></div>
</div>
